<template>
  <v-autocomplete
    v-model="tags"
    :items="items"
    outlined
    label="Add new unit tag"
    class="mt-2"
    hide-details
    small-chips
    chips
    multiple
    deletable-chips
    item-text="text"
    item-value="value"
    dense
    @update:search-input="updateSearchInput"
  >
    <template v-slot:selection="{ attrs, item, select, selected }">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        close
        small
        class="mt-1"
        @click="select"
        @click:close="deleteUnitTag(item)"
      >
        {{ item.text }}
      </v-chip>
    </template>
    <template v-slot:append-item>
      <div class="d-flex flex-grow">
        <v-btn
          v-show="isNewTagTruthy && notPropertyTagsInclude"
          class="ma-auto"
          color="primary"
          depressed
          @click="addUnitTagDialog"
        >
          <v-icon small class="mr-2"> mdi-plus </v-icon> Create: "{{
            newUnitTag
          }}"
        </v-btn>
      </div>
    </template>
    <template v-slot:no-data>
      <div />
    </template>
    <template v-slot:item="{ active, item, attrs }">
      <v-list-item
        v-show="notTagIncludes(item)"
        v-bind="attrs"
        #default="{ active }"
        @click="addUnitTag(item)"
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters align="center">
              <v-chip text-color="white" :color="item.color" small>
                {{ item.text }}
              </v-chip>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { toSnakeCase } from '../../util/string'

export default {
  props: ['items', 'tags', 'unitType', 'bedId', 'groupId'],
  data() {
    return {
      newUnitTag: '',
      loading: false
    }
  },
  computed: {
    isNewTagTruthy() {
      return this.newUnitTag != null
    },
    notPropertyTagsInclude() {
      if (!this.newUnitTag) {
        return false
      }
      return (
        this.items.findIndex(
          (t) => t.value === toSnakeCase(this.newUnitTag)
        ) === -1
      )
    }
  },
  methods: {
    async addUnitTag(item) {
      try {
        const tagToInsertAPI = (item && item.text) || this.newUnitTag
        const tagToPushUI = item || {
          value: toSnakeCase(this.newUnitTag),
          text: this.newUnitTag
        }
        this.tags.push(tagToPushUI)
        this.items.push(tagToPushUI)

        switch (this.unitType) {
          case 'unit':
            // check if bedId exists
            if (this.bedId == null) {
              // eslint-disable-next-line
              console.log('bedId and unit type does not match')
              return
            }

            await this.$store.dispatch('units/addUnitTagAction', {
              bedId: this.bedId,
              tag: tagToInsertAPI
            })
            break

          case 'group':
            // check if groupId exists
            if (this.groupId == null) {
              // eslint-disable-next-line
              console.log('groupId and unit type does not match')
              return
            }
            await this.$store.dispatch('units/addGroupTagAction', {
              groupId: this.groupId,
              tag: tagToInsertAPI
            })
            break

          case 'new_unit':
          default:
            break
        }

        // emit the data to units if new tag to be created
        if (!item) {
          // emit the data to units
          this.$emit('addTag', tagToPushUI)
        }
        this.newUnitTag = ''
      } catch (err) {
        this.$emit('addTagError', err.data || err)
      }
    },
    async deleteUnitTag(toRemove) {
      if (this.unitType === 'new_unit') {
        this.tags = this.tags.filter((tag) => tag != toRemove)
        return
      }

      const dialogOptions = {
        title: 'Delete Unit Tag',
        message: 'Are you sure you want to delete this tag?',
        confirmText: 'CONFIRM',
        options: {
          zIndex: 205
        }
      }
      try {
        const resolve = await this.$root.$confirm(dialogOptions)
        if (resolve) {
          this.loading = true
          let newTags = []
          switch (this.unitType) {
            case 'unit':
              // check if bedId exists
              if (this.bedId == null) {
                // eslint-disable-next-line
                console.log('bedId and unit type does not match')
                return
              }
              newTags = await this.$store.dispatch(
                'units/deleteUnitTagAction',
                { bedId: this.bedId, tag: toRemove.value }
              )
              break

            case 'group':
              // check if groupId exists
              if (this.groupId == null) {
                // eslint-disable-next-line
                console.log('groupId and unit type does not match')
                return
              }
              newTags = await this.$store.dispatch(
                'units/deleteGroupTagAction',
                { groupId: this.groupId, tag: toRemove.value }
              )
              break

            case 'new_unit':
            default:
              break
          }
          this.tags = newTags.data
          this.newUnitTag = null
          this.loading = false
        }
      } catch (err) {
        this.$emit('addTagError', err.data)
        this.loading = false
      }
    },
    async addUnitTagDialog() {
      const dialogOptions = {
        title: 'Add Unit Tag',
        message: `Are you sure you want to add a new tag "${this.newUnitTag}"?`,
        confirmText: 'CONFIRM'
      }
      const resolve = await this.$root.$confirm(dialogOptions)
      if (resolve) {
        this.addUnitTag()
      }
    },
    notTagIncludes(tag) {
      return this.tags.findIndex((t) => t.value === tag.value) === -1
    },
    updateSearchInput(val) {
      this.newUnitTag = val
    }
  }
}
</script>
